module.exports = __webpack_public_path__ + "img/eshoy_home_top01.af8842f3.png";